import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import StoreLayout from "@/components/StoreLayout";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import Checkout from "@/pages/Checkout";
import Pay from "@/pages/Pay";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import Policies from "@/pages/Policies";
import TrackOrder from "@/pages/TrackOrder";
import Contact from "@/pages/Contact";
import POS from "@/pages/POS";
import Closing from "@/pages/Closing";
import Receipt from "@/pages/Receipt";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminReturns from "@/pages/admin/AdminReturns";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminDelivery from "@/pages/admin/AdminDelivery";
import AdminReports from "@/pages/admin/AdminReports";
import AdminCleanup from "@/pages/admin/AdminCleanup";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Catalogue />} />
                <Route path="/search" element={<Catalogue />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/pay/:id" element={<Pay />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/track" element={<TrackOrder />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
              </Route>

              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route path="/pos" element={<ProtectedRoute roles={["seller", "owner"]}><POS /></ProtectedRoute>} />
              <Route path="/pos/closing" element={<ProtectedRoute roles={["seller", "owner"]}><Closing /></ProtectedRoute>} />
              <Route path="/pos/receipt/:id" element={<ProtectedRoute roles={["seller", "owner"]}><Receipt /></ProtectedRoute>} />

              <Route path="/admin" element={<ProtectedRoute roles={["owner"]}><AdminLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="invoices" element={<AdminInvoices />} />
                <Route path="returns" element={<AdminReturns />} />
                <Route path="reports" element={<AdminReports />} />
                <Route path="delivery" element={<AdminDelivery />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="audit" element={<AdminAudit />} />
                <Route path="cleanup" element={<AdminCleanup />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
